import React, { useState, useEffect, useContext } from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import EditIcon from '@mui/icons-material/Edit';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import DeleteIcon from '@mui/icons-material/Delete';

import { BlogContext } from '../../contexts/BlogContext';
import { OptionsContext } from '../../contexts/OptionsContext';

import BlogForm from '../CMSForm/BlogForm';

import './ManageFacilities.css';


const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.black, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.black, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

function ManageBlogs() {
  const { getBlogs, blogs, getBlogCount, blogCount, searchBlog, blogsSearch, publishBlog, deleteBlog, page, setPage } = useContext(BlogContext)
  const { getTags } = useContext(OptionsContext)
  const [hidden, setHidden] = useState(false)
  const [searchString, setSearchString] = useState('')
  const [filteredData, setFilteredData] = useState([])
  const [editFormData, setEditFormData] = useState({})


  function toggleForm() {
    setHidden(!hidden)
  }

  useEffect(() => {
    getBlogCount()
    getTags()
  }, [])

  useEffect(() => {
    if (searchString !== '') {
      searchBlog(searchString)
    } else {
      getBlogs(page)
    }
  }, [page])


  useEffect(() => {
    if (searchString !== '') {
      return
    }
    setFilteredData([...processData(blogs)])
  }, [blogs])


  useEffect(() => {
    if (searchString !== '') {
      setFilteredData([...processData(blogsSearch)])
    }
  }, [blogsSearch])


  function processData(data) {
    const newData = data.map(e => createData(e.title, e.shortDescription, e.create_date, e.published))
    return newData
  }

  function createData(title, shortDescription, create_date, published) {
    return { title, shortDescription, create_date, published };
  }

  function handleSearch(e) {
    let string = e.target.value
    setSearchString(string)
    setPage(1)

    if (string !== '') {
      searchBlog(string)
    }
    else {
      getBlogs(1)
    }
  }

  function handleCreateNew() {
    setEditFormData({})
    toggleForm()
  }

  function handleEditClick(i) {
    let selected = getCurrListData(i)
    setEditFormData({ ...selected })
    toggleForm()
  }

  function handlePublish(i) {
    let selected = getCurrListData(i)
    publishBlog(selected._id, !selected.published)
  }

  function getCurrListData(i) {
    if (searchString !== '') {
      return blogsSearch[i]
    }
    else {
        return blogs[i]
    }
  }

  function handleDeleteClick(i) {
    let selected = getCurrListData(i)
    const confirm = window.confirm('Are you sure you want to delete this blog?')
    if (confirm) {
      deleteBlog(selected._id)
    }
  }

  return (
    <div>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar style={{ backgroundColor: 'white' }} position="static">
          <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }} >
            <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ 'aria-label': 'search' }}
                onChange={(e) => { handleSearch(e) }}
                value={searchString}
              />
            </Search>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button onClick={handleCreateNew} variant="contained">Create New</Button>
            </div>
          </Toolbar>
        </AppBar>
      </Box>

      {/* form */}
      {hidden && <BlogForm
        initialData={editFormData}
        closeForm={() => { toggleForm() }}
      />}


      <TableContainer style={{ marginTop: '30px' }} component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Posted Date</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.map((row, i) => (
              <TableRow
                key={row.title + i}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell>{row.title}</TableCell>
                <TableCell>{row.shortDescription}</TableCell>
                <TableCell>{new Date(row.create_date).toLocaleDateString()}</TableCell>
                <TableCell>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>

                    <TableOption
                      color={'inherit'}
                      name={filteredData[i].published ? 'Unpublsih' : 'Publish'}
                      onClick={() => { handlePublish(i) }}
                    >
                      {filteredData[i].published ?
                        <RemoveRedEyeIcon />
                        :
                        <VisibilityOffIcon />
                      }
                    </TableOption>

                    <TableOption
                      color={'primary'}
                      name={'Edit'}
                      onClick={() => { handleEditClick(i) }}
                    >
                      <EditIcon />
                    </TableOption>

                    <TableOption
                      color={'primary'}
                      name={'Delete'}
                      onClick={() => { handleDeleteClick(i) }}
                    >
                      <DeleteIcon />
                    </TableOption>

                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {blogCount > 15 &&
        <div style={{ width: '100%', margin: '40px 0px', display: 'flex', justifyContent: 'center' }}>
          <Stack spacing={2}>
            <Pagination page={page} onChange={(e, i) => { setPage(i) }} count={Math.ceil(blogCount / 15)} showFirstButton={blogCount / 15 > 5 ? true : false} showLastButton={blogCount / 15 > 5 ? true : false} />
          </Stack>
        </div>
      }
    </div>
  )
}

export default ManageBlogs

const TableOption = ({ children, name, color, onClick }) => {
  return (
    <div style={{ margin: '0px 10px', cursor: 'pointer' }} onClick={onClick}>
      <Tooltip title={name}>
        <IconButton color={color}>
          {children}
        </IconButton>
      </Tooltip>
    </div>
  )
}